import {createContext} from 'react'
// import React, {useState} from 'react'

export const MyContext =  createContext({} );

 